import { connect } from 'react-redux';

import get from 'lodash/get';

import JobFeedSection from './job_feed.jsx';

import {
  NO_STYLE_PRESET_CLASSNAME
} from 'zoomforth_codesbane_viewer/const/style_presets.js';

import {
  getSectionSingletonContentItem,
  getFilteredApiFeed,
  getIsLoadingFilteredApiFeed,
  getErrorInFilteredApiFeed
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getHeightStyle
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import {
  getBackgroundStyle
} from 'zoomforth_codesbane_viewer/lib/section_backgrounds.js';


import {
  getIsCurrentSubpageFullPageSection,
  getSectionBackgroundData
} from 'zoomforth_codesbane_viewer/reducers/index.js';


import {
  fetchFilteredApiFeed
} from 'zoomforth_codesbane_viewer/action_creators/filtered_api_feeds.js';


const mapStateToProps = (state, { section }) => {
  const contentItem = getSectionSingletonContentItem(state, section);
  const hasFetchError = getErrorInFilteredApiFeed(state);
  const isLoading = getIsLoadingFilteredApiFeed(state);

  var apiFeed, jobs, displayFields, type;
  if (!isLoading) {
    apiFeed = getFilteredApiFeed(state, section.apiFeedId, { filters: section.filters });
    jobs = apiFeed ? apiFeed.last_proc_data : null; // Note this data is pre-filtered on the python side 
    displayFields = get(apiFeed, 'display_fields');
  }


  const isFullPage = getIsCurrentSubpageFullPageSection(state);
  const height = getHeightStyle(section);
  const sectionBackgroundData = getSectionBackgroundData(state, section);
  const backgroundStyle = getBackgroundStyle(sectionBackgroundData);


  return {
    uuid: !contentItem ? contentItem.uuid : null,
    fontSize: contentItem ? contentItem.font_size : null,
    displayFields,
    jobs,
    hasFetchError,
    isLoading, 
    isFullPage,
    height,
    backgroundStyle,
    stylePresetClassName: contentItem ? contentItem.style_preset_classname : NO_STYLE_PRESET_CLASSNAME
  };
};

const mapDispatchToProps = (dispatch, { section }) => ({

  onJobFeedLoad: ()=> {
    dispatch(fetchFilteredApiFeed(section.apiFeedId, { filters: section.filters }));
  }

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobFeedSection);
